import { render, staticRenderFns } from "./modulo.vue?vue&type=template&id=78a61cd5"
import script from "./modulo.vue?vue&type=script&lang=js"
export * from "./modulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports